import type { PaginatedQueryParams } from 'queries/queries-utils'
import type { UseGetReliabilityTestsByIdQueryParams } from 'queries/reliability-tests/types'

export const reliabilityTestsQueryKeys = {
  getActivePaged: (params: { teamId: string } & PaginatedQueryParams) =>
    ['reliability-tests/active/paged', params] as const,
  getCompletedPaged: (params: { teamId: string } & PaginatedQueryParams) =>
    ['reliability-tests/completed/paged', params] as const,
  getReliabilityTestRunsById: (query: UseGetReliabilityTestsByIdQueryParams) =>
    [`reliability-tests/${query.reliabilityTestId}/runs`, query] as const
}
